import React from 'react';
import AboutContent from '../layout/About';

export default function About() {
  return (
    <div>
      <h1 style={{ margin: '48px 0 12px 0' }}>O nás</h1>
      <AboutContent />
    </div>
  );
}
